export default __webpack_public_path__ + "static/media/EuropeTravel.f9928462.jpg";